<template>
  <div class="pass-list-item-footer">
    <TrailProgressLine :trail="{ progress: item.progress }" />
    <div class="content">
      <div class="item" v-for="(item, index) in items" :key="index">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import TrailProgressLine from '@/trail/components/trail-progress-line';

export default defineComponent({
  name: 'PassListItemFooter',

  /**
   * 属性
   */
  props: {
    item: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    items() {
      return [
        `${this.item.meta.nodeCount}节`,
        `${this.item.meta.packCount}集`,
        `${this.item.meta.seriesCount}段行程`,
      ];
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    TrailProgressLine,
  },
});
</script>

<style scoped>
@import './styles/pass-list-item-footer.css';
</style>
